
/**
 * **攻撃宣言**（Issue #535）。
 *
 * 開く: `attack`。**舞台を仮想フィールドに切り替え、斜め上から寄る**（`scene`）。
 * 戻すのは `damage_step_end` / `new_phase` / `new_turn`（別のファイルが `scene: 'reset'`）。
 *
 * **舞台の設定はグローバル 1 枠**（設計文書 §6.1）—— カメラも Field も舞台が 1 つ持つものなので
 * オブジェクトレイヤーには入れない。演出が出せるのは**要求**だけで、戻すのは器。
 */
/** 状況ごとのファイル（`../effects/attack_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: '攻撃宣言',
  color: '#ff7a3d',
  sounds: () => [{ at: 0, name: 'attack_decl' }],

  opens({ payload }) {
    const a = payload?.attacker;
    if (!a?.uid) return null;
    // 層の `{uid}` / `{zone}` が攻撃するカードを指すように持ち上げる
    return { ...payload, uid: a.uid, zone: a.zone };
  },

  /**
   * **舞台への要求**。実写を仮想フィールドに置き換え、カメラを斜めへ送る。
   * ショットの名前は `stage/camera.js` の `SHOTS` にある綴りだけ（知らないものは素のまま）。
   */
  scene: [
    { ms: 0, field: 'virtual', shot: 'live' },
    { ms: 0, shot: 'tilt' },
  ],

  layers: [
    {
      id: 'lock',
      label: '攻撃側の照準',
      part: 'ring',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { color: '#ff7a3d', ticks: 8 },
      tf: {
        scale: { keys: [{ ms: 0, value: 1.8 }, { ms: 300, value: 1.05, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 120, value: 1 }, { ms: 700, value: 0 }] },
        rotation: { keys: [{ ms: 0, value: 0 }, { ms: 700, value: 60 }] },
      },
    },
  ],
};
